import { render, staticRenderFns } from "./DepInfo.vue?vue&type=template&id=50ae7536&scoped=true&"
import script from "./DepInfo.vue?vue&type=script&lang=js&"
export * from "./DepInfo.vue?vue&type=script&lang=js&"
import style0 from "./DepInfo.vue?vue&type=style&index=0&id=50ae7536&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ae7536",
  null
  
)

export default component.exports